import { BrowserRouter as Router } from "react-router-dom";
import './App.css'
import { DataProvider } from './context/data'
import {HeroUIProvider, ToastProvider} from "@heroui/react";
import { Suspense } from 'react';
import AppRoutes from './routes/index';
import { ToastProvider as LocalToast } from "./context/toast";
import { AuthProvider } from "./context/auth";
import Loader from './components/loader';
import moment from 'moment';
import 'moment/locale/fr';
import { Chart, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


moment.locale('fr');


function App() {
  
  return (
    <HeroUIProvider>
      <DataProvider>
        <LocalToast>
          <ToastProvider/>
          <Router>
            <AuthProvider>
              <Suspense fallback={<Loader/>}>
                <AppRoutes/>
              </Suspense>
            </AuthProvider>
          </Router>
        </LocalToast>
      </DataProvider>
    </HeroUIProvider>
  )
}

export default App
